<div class="carga" [ngStyle]="{'heigth': height, 'width': width}"></div>
